var _style, _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 192",
    style: {
      enableBackground: "new 0 0 192 192"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0Whatsapp{fill:none;}\n\t.st1Whatsapp{fill:none;stroke:var(--textInSecondaryColor);stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:3;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0Whatsapp",
    width: 192,
    height: 192
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1Whatsapp",
    d: "M34.1,132.7c-20.3-34.2-9-78.3,25.2-98.6s78.3-9,98.6,25.2s9,78.3-25.2,98.6c-22.6,13.4-50.8,13.4-73.4,0l0,0 L34.4,165c-3.2,0.9-6.5-0.9-7.4-4.1c-0.3-1.1-0.3-2.2,0-3.3L34.1,132.7L34.1,132.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1Whatsapp",
    d: "M114.1,138c-33.1,0-60-26.8-60.1-59.9c0-0.1,0-0.1,0-0.2C54,66.3,63.4,57,75,57l0,0c1.9,0,3.6,1,4.5,2.6 l8.8,15.3c1.1,1.9,1.1,4.2-0.1,6.1l-7,11.7l0,0c3.6,8,10.1,14.5,18.1,18.1l0,0l11.7-7c1.9-1.1,4.2-1.1,6.1-0.1l15.3,8.8 c1.6,0.9,2.6,2.6,2.6,4.5l0,0C135,128.6,125.6,137.9,114.1,138z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLogo);
export default __webpack_public_path__ + "static/media/whatsapp-logo.c101fc98.svg";
export { ForwardRef as ReactComponent };